<!--
 * @Author: hfxie
 * @Date: 2021-01-01 17:10:10
 * @LastEditors: haifeng_xie haifeng_xie@kingdee.com
 * @LastEditTime: 2023-09-07 16:30:49
 * @Description: 主组件入口
-->

<template>
  <div
    class="component-box"
    :data-page-id="uuid"
    :id="uuid"
  >

    <CqLoading v-if="$store.state.dataLoadingStatus === true" />
    <template v-else>
      <ToolBar v-if="toolbarShow"/>
      <List :toolbarShow="toolbarShow" />
    </template>
  </div>
</template>

<script>
import CONSTNAME from "@/ConstName.js";
import CqLoading from "./components/CqLoading/CqLoading.vue";
import ToolBar from "./components/ToolBar/ToolBar";
import List from "./components/List/List";
export default {
  name: "App",
  data() {
    return {
      CONSTNAME,
      toolbarShow: false,
    };
  },
  created() {},
  mounted() {},

  methods: {

  },
  components: {
    CqLoading,
    ToolBar,
    List,
  },
  computed: {
    uuid() {
      return this.$store.state.uuid;
    },
  },
};
</script>

<style lang="less" scoped>
.component-box {
  position: relative;
  color: #000;
  background-color: #ffffff;
  width: 100%;
  min-width: @minWidth;
  box-sizing: border-box;
  height: 100%;
  margin: 0 auto;
  padding: 0;
  user-select: none;
  font-family: "Microsoft YaHei", PingFangSC-Regular, "Helvetica Neue",
    Helvetica, Arial, "Hiragino Sans GB", "WenQuanYi Micro Hei", sans-serif;
  .hide {
    display: none !important;
  }
  .box-content {
    border: 1px dashed #e1453e;
    margin-bottom: 20px;
  }

  ::v-deep.el-loading-mask{
    font-size: 20px;
  }
}
</style>
